export const SENSITIVE_VAULT_VERSION = 1;

export const SENSITIVE_VAULT_KDF = 'pbkdf2';
export const SENSITIVE_VAULT_PBKDF2_ITERATIONS = 200000;
export const SENSITIVE_VAULT_SALT_BYTES = 16;

export const SENSITIVE_VAULT_AES_ALGO = 'aes-256-gcm';
export const SENSITIVE_VAULT_KEY_BYTES = 32;
export const SENSITIVE_VAULT_IV_BYTES = 12;
